// intro
import { useHistory } from 'react-router-dom';

import { Row, Col } from 'antd';

export default function ButtonActionsLink (props) {

  const data = props.data;
  const history = useHistory();

  return (
  <>
    <div className={``} >
      <div className={`p-1 px-2 rounded-wd hirich cursor ${data.backcolor} ${data.textcolor}`}
        onClick={() => history.push(data.link)}
      >
        <Row justify="space-between">
          <Col span={21}>
            <Row justify="start" align="middle">
              <Col>
                <i className={`bx m-0 text-icon-sm ${data.icon}`}></i>
              </Col >
              <Col flex="auto" className="mx-1 text-left">{data.text}</Col>
            </Row>
          </Col>

          <Col span={3} className="text-end">
            <i className="bx bx-chevron-right text-color-tone m-0 text-icon-sm" ></i>
          </Col>
        </Row>
      </div>
    </div>
  </>

  )
}